import { Outlet } from "react-router-dom";
import { BlockingModal } from "@/services/blocking-modal";
import { Content } from "../Content";
import { AppHeader } from "../AppHeader";

export const Page = () => {
  return (
    <>
      <AppHeader />
      <Content>
        <Outlet />
      </Content>
      <BlockingModal />
    </>
  );
};
